<template>
  <div>
    <h2><slot></slot></h2>
    <div class="border"></div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  data () {
    return {
      search: '',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    h2 {
      font-size:34px;
      font-family:PingFangSC-Regular;
      line-height:48px;
      padding-bottom: 40px;
      margin: 0 auto;
      text-align: center;
    }

    .border {
      width:70px;
      height:3px;
      background:rgba(51,51,51,1);
      margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/home/Title.vue